import { Search, Settings, Bell, MessageSquare } from 'lucide-react'
import styles from './TopBar.module.css'

export function TopBar() {
  return (
    <header className={styles.topBar}>
      <div className={styles.left}>
        <button className={styles.waffle} aria-label="App launcher">
          <span className={styles.waffleDot} />
          <span className={styles.waffleDot} />
          <span className={styles.waffleDot} />
          <span className={styles.waffleDot} />
          <span className={styles.waffleDot} />
          <span className={styles.waffleDot} />
          <span className={styles.waffleDot} />
          <span className={styles.waffleDot} />
          <span className={styles.waffleDot} />
        </button>
        <span className={styles.brandName}>Outlook</span>
      </div>

      <div className={styles.center}>
        <div className={styles.searchWrapper}>
          <Search size={16} className={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search"
            className={styles.searchInput}
            aria-label="Search"
          />
        </div>
      </div>

      <div className={styles.right}>
        <button className={styles.iconBtn} aria-label="People">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="8" cy="7" r="3.5" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="14" cy="7" r="2.5" stroke="currentColor" strokeWidth="1.5" />
            <path d="M1 17c0-3.314 3.134-6 7-6s7 2.686 7 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
            <path d="M17 13c1.657 0 3 1.343 3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
        </button>
        <button className={styles.iconBtn} aria-label="Chat">
          <MessageSquare size={20} />
        </button>
        <button className={styles.iconBtn} aria-label="Notifications">
          <Bell size={20} />
        </button>
        <button className={styles.iconBtn} aria-label="Settings">
          <Settings size={20} />
        </button>
        <button className={styles.avatar} aria-label="Profile">
          TH
        </button>
      </div>
    </header>
  )
}
